import User from "../User";

export default class TAP {
	id!: number;

	approvalStatus?: string;

	startingTime?: Date;

	createdTime!: Date;

	requestor!: User;

	approver!: User;

	onBehalf!: User;

	tapId!: number;

	taPass?: string;

	constructor(obj: any) {
		if (obj != ''){
			Object.assign(this, obj);
		}
	}
}